import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import Form from 'erpcore/components/Form';

import Button from 'erpcore/components/Button';
import Modal from 'erpcore/components/Modal';
import Svg from 'erpcore/components/Svg';
import Tooltip from 'erpcore/components/Tooltip';

import { actions as rolesActions } from 'erpcore/screens/Settings/Roles/Roles.reducer';

class RoleDelete extends Component {
    constructor(props) {
        super(props);

        this.state = {
            opened: false
        };

        this.handleModal = this.handleModal.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit() {
        const { dispatch, roleData } = this.props;

        return new Promise((resolve, reject) =>
            dispatch({
                promise: { resolve, reject },
                type: rolesActions.START_DELETE_ROLE,
                roleIri: roleData?.iri
            })
        )
            .then(() => {
                this.setState({ opened: false });
            })
            .catch(error => {
                return error;
            });
    }

    handleModal() {
        const { opened: isOpen } = this.state;
        this.setState({ opened: !isOpen });
    }

    render() {
        const { roleData, handleSubmit, submitting } = this.props;
        const { opened } = this.state;

        return (
            <Fragment>
                <Tooltip content="Delete role">
                    <button type="button" onClick={() => this.handleModal()}>
                        <Svg icon="remove" />
                    </button>
                </Tooltip>
                <Modal
                    variation="medium"
                    opened={opened}
                    onClose={() => this.handleModal()}
                    title="Delete role"
                    subtitle={
                        <Fragment>
                            Are you sure you want to delete <em>{roleData && roleData?.name}?</em>
                        </Fragment>
                    }
                >
                    <Form onSubmit={handleSubmit(this.onSubmit)}>
                        <Button submit loading={submitting} label="Delete" />
                        <Button
                            variation="secondary"
                            label="Cancel"
                            onClick={() => this.handleModal()}
                        />
                    </Form>
                </Modal>
            </Fragment>
        );
    }
}

RoleDelete.defaultProps = {
    submitting: false,
    roleData: {}
};

RoleDelete.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    roleData: PropTypes.oneOfType([PropTypes.object]),
    dispatch: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownProps) => {
    const { roleData } = ownProps;

    return {
        form: `RoleDeleteForm-${roleData?.iri}`,
        initialValues: { name: roleData?.name }
    };
};

RoleDelete = reduxForm({
    enableReinitialize: false
})(RoleDelete);

export default connect(mapStateToProps)(RoleDelete);
